import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [
	{ title: 'Personal Insurance' },
	{
		name: 'description',
		content: 'We offer a variety of personal insurance products.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Personal Insurance</h1>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<h3>
					<strong>Property Coverage</strong>
				</h3>
				<strong>
					<Link
						to="/products/homeowners-insurance"
						className="text-blue-600 underline"
						prefetch="intent"
					>
						Homeowner
					</Link>
				</strong>
				Your home is your castle. Make sure you have the protection you need
				when the unexpected occurs.
				<strong>Landlord Property</strong>
				If you have a rental property with one unit or one hundred, we have a
				solution for you.
				<strong>Farm</strong>
				Whether you're a full-scale farmer with a sophisticated setup or a mere
				hobby farmer with a few beehives in your back yard, we should talk.
				<strong>Mobile Home</strong>
				Your manufactured home or mobile home has different coverage
				requirements than a house built on site.
				<strong>Renter</strong>
				If you don't own a home, you may need renter's insurance to cover your
				personal liability and your belongings. It's inexpensive and invaluable.
				<strong>Flood</strong>
				The{' '}
				<a
					href="http://www.fema.gov/"
					target="_blank"
					rel="noopener noreferrer"
				>
					Federal Emergency Management Agency (FEMA) (opens in a new tab)
				</a>{' '}
				operates the{' '}
				<a
					href="http://www.fema.gov/business/nfip/"
					target="_blank"
					rel="noopener noreferrer"
				>
					National Flood Insurance Plan (NFIP) (opens in a new tab)
				</a>
				, allowing insurance companies to offer flood insurance. Since it's
				government-run, the costs are the same for all insurance companies. We
				can help you secure flood insurance before the floodwater even arrives.
				<strong />
				<h3>
					<strong>Vehicles</strong>
				</h3>
				<strong>Automobile</strong>
				Lets have a chat that could save you 17% on your auto insurance. It's
				simple, but you don't want a caveman doing it. Give the Steele Agency a
				call.
				<strong>Motorcycle &amp; ATV</strong>
				Whether you're new to riding or have years of experience, it's a good
				idea to take another look at your motorcycle insurance coverage.
				<strong>Snowmobile</strong>
				If you long for the snow to fall so you can get out and ride, let us
				take care of your snowmobile insurance so you can hit the trails.
				<strong>Antique Car</strong>
				Many people are pleasantly surprised to find out how affordable it is to
				purchase coverage for your classic car.
				<strong>Boat</strong>
				Some companies can provide coverage for your boat by adding it to your
				homeowner's policy, while others write a separate policy. We'll help you
				decide on the best option in your own circumstances.
				<strong>Aircraft</strong>
				We can cover your small plane.
				<h3>
					<strong>Other</strong>
				</h3>
				<strong>Umbrella</strong>
				The Umbrella policy fills gaps in coverage and provides an added limit
				of liability on top of your existing homeowner, automobile, and other
				policies.
				<strong>Jewelry</strong>
				We can offer coverage on your jewelry and valuables.
				<strong>Collectibles</strong>
				We cover your special collections.
			</p>
		</main>
	)
}
